import React, { useEffect } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect } from "react-redux"
import { Col, UncontrolledTooltip, Table } from "reactstrap"
import PropTypes from "prop-types"
import { isEmpty, get } from "lodash"
import * as quotationAction from "../../store/cXVvdGF0/actions"

const OverallDeliverables = (props) => {
  const { dispatch } = props
  let { id } = useParams()
  useEffect(() => {
    dispatch(quotationAction.loadDeliverableDetails(id))
  }, [])

  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const { deliverable_details } = quotationUpdate

  const deliverableData = deliverable_details
  //Deliverable Data Table section
  const deliverDataTable = !isEmpty(deliverableData)
    ? deliverableData.map((deliver, index) => {
        const deliverId = get(deliver, "_id", "")
        const deliverStatus = get(deliver, "status", "")
        const deliverQuantity = get(deliver, "quantity", "No quantity")
        const deliverActualPrice = get(deliver, "actualPrice", "No actualPrice")
        const deliverQuotePrice = get(deliver, "quotePrice", "No quotePrice")
        // const deliverDiscount = get(deliver, "discount", "No discount")
        const deliverUpselling = get(deliver, "upselling", "No upselling")
        const deliverFinalAmount = get(deliver, "finalAmount", "No price")
        const deliverableType = get(
          deliver,
          "deliverableName",
          "No deliverableType"
        )
        const deliverProduct = get(deliver, "productName", "No product Name")
        const deliverCommercial = get(deliver, "commercialMode", "No price")
        const deliveryMode = get(deliver, "deliveryModeName", "No deliver")

        return {
          _id: deliverId,
          sNo: index + 1,
          status: deliverStatus,
          eventNo:
            !isEmpty(deliver) && deliver.eventNo && deliver.eventNo.length > 0
              ? deliver.eventNo.join(" , ")
              : deliver.eventNo,
          eventName:
            !isEmpty(deliver) && deliver.eventName ? deliver.eventName : [],
          eventId:
            !isEmpty(deliver) && deliver.eventId && deliver.eventId.length > 0
              ? deliver.eventId.join(" , ")
              : deliver.eventId,
          deliverableType: deliverableType,
          deliverableId: deliver.deliverableId,
          productId: deliver.productId,
          productName: deliverProduct,
          commercialMode: deliverCommercial,
          quantity: deliverQuantity,
          actualPrice: deliverActualPrice,
          quotePrice: deliverQuotePrice,
          discount: deliver.discount,
          count: deliver.count,
          sheet: deliver.sheetLength,
          length: deliver.length,
          finalAmount: deliverFinalAmount,
          upselling: deliverUpselling,
          deliveryModeName: deliveryMode,
          deliveryModeId: deliver.deliveryModeId,
        }
      })
    : []

  return (
    <>
      <Col lg="12" md="12" xl="12" className="quote-head-content">
        <p className="quote-head">
          Overall Deliverables
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="OverallDeliverablesInfo"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip
              placement="right"
              target="OverallDeliverablesInfo"
            >
              Overall Deliverables Description
            </UncontrolledTooltip>
          </span>
        </p>
      </Col>
      <Col md="12" lg="12" xl="12">
        <Table striped responsive className="w-100 mt-3 mb-2">
          <thead>
            <tr style={{ fontSize: "10px" }}>
              <th>S.No</th>

              <th style={{ minWidth: "160px" }}>Event No</th>
              <th style={{ minWidth: "160px" }}>Event Name</th>
              <th style={{ minWidth: "170px" }}>Deliverable Type</th>
              <th style={{ minWidth: "160px" }}>Product Name</th>
              <th style={{ minWidth: "170px" }}>Commercial Mode</th>
              <th style={{ minWidth: "160px" }}>Count/Sheet</th>
              <th>Qty</th>
              {/* <th>Quoted</th>
              <th>Discount</th>
              <th>Upselling</th>
              <th>Final Amount</th> */}
            </tr>
          </thead>
          <tbody>
            {deliverDataTable.length > 0 ? (
              deliverDataTable.map((deliver) => {
                console.log(deliver.eventNo, "")
                return (
                  <tr key={deliver._id}>
                    <td>{deliver.sNo}</td>

                    <td>{deliver.eventNo}</td>
                    <td style={{ paddingRight: "50px" }}>
                      {deliver.eventName.length > 1
                        ? deliver.eventName + ","
                        : deliver.eventName}
                    </td>
                    <td>{deliver.deliverableType}</td>
                    <td>{deliver.productName}</td>
                    <td>{deliver.commercialMode}</td>
                    <td>
                      {deliver.count === null ? 0 : deliver.count} /{" "}
                      {deliver.sheet === null ? 0 : deliver.sheet}
                    </td>
                    <td className="event-table-value">{deliver.quantity}</td>
                    {/* <td
                      className="event-table-value"
                      style={{ color: "#34c38f" }}
                    >
                      {deliver.actualPrice + ".00"}
                    </td>
                    <td
                      className="event-table-value"
                      style={{ color: "#f1153e" }}
                    >
                      {deliver.discount + ".00"}
                    </td>
                    <td className="event-table-value">
                      {deliver.upselling + ".00"}
                    </td>
                    <td
                      className="event-table-value"
                      style={{ color: "#086fc7" }}
                    >
                      {deliver.finalAmount + ".00"}
                    </td> */}
                  </tr>
                )
              })
            ) : (
              <>
                <tr key={0}>
                  <td colSpan={13} className="text-align-center">
                    No record found
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </Table>
      </Col>
    </>
  )
}
OverallDeliverables.propTypes = {
  dispatch: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OverallDeliverables)
)
